import zhLocale from 'element-ui/lib/locale/lang/zh-CN' // 引入element语言包
// 需要转换的中文
const cn = {
  back: '返回',
  ...zhLocale
}

export default cn
